import { Component } from '@angular/core';
import { Menu } from '../../../core/models/menu-permission.model';
import { MenuPermissionService } from '../../../core/services/menu-permission.service';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

declare var KTMenu: any;
declare var KTComponents: any;
@Component({
  selector: '[app-sidebar]',
  standalone: true,
  templateUrl: './sidebar.component.html',
  imports : [MenuItemComponent, RouterModule, CommonModule]
})
export class SidebarComponent {
  menu: Menu[] = [];

   constructor(
        private menuPermissionService: MenuPermissionService,
        private router: Router
      ) {

        setTimeout(() => {

                try {

                  if (typeof KTComponents !== 'undefined') {

                    KTComponents.init();

                    console.log('KTComponents initialized');
                  }

                } catch (e) {
                  console.error(e);
                }

              }, 300);
      }

  ngOnInit() {
    this.loadMenu();
  }

  loadMenu() {
    this.menuPermissionService.getMenusByUser().subscribe(res => {
      this.menu = res;
      console.log("Menu all see",res);
      
      //
      setTimeout(() => this.initMenu(), 100);
    });
  }

  ngAfterViewInit() {
    this.initMenu();
  }
  initMenu() {
    const el = document.querySelector('#sidebar_menu');

    if (el) {
      KTMenu.createInstances(); // 🔥 re-init
    }
  }

  isModuleExpanded(module: any): boolean {

    return module.children?.some((parent: any) =>
      parent.children?.some((menu: any) =>
        menu.route &&
        this.router.url.startsWith(menu.route)
      )
    );
  }

}